import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class FaceDownInstruction extends Instruction<"face-down"> {
  readonly type = "face-down";

  act(context: ProgramModel) {
    context.cursorDirection = "down";
  }
}
